import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";
import { CopyChartService } from "../../../platform/api/copy-chart/copy-chart.service";

@Component({
    selector: "app-more-actions-modal",
    templateUrl: "./more-actions-modal.component.html",
    styleUrls: ["./more-actions-modal.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MoreActionsModalComponent {
    private Visible = false;

    @Input()
    get visible(): boolean {
        return this.Visible;
    }
    set visible(value: boolean) {
        this.Visible = value;
        this.visibleChange.emit(this.visible);
    }

    @Output() continue = new EventEmitter<void>();
    @Output() visibleChange = new EventEmitter<boolean>();
    @Output() onHide = new EventEmitter<null>(true);

    constructor(
        private readonly copyChartService: CopyChartService
    ) {}


    cancel(): void {
        this.copyChartService.clearChaseGrid();
        this.onHide.emit();
    }

    onContinue(): void {
        this.continue.emit();
        this.visible = false;
    }
}

